var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"d-inline textgradient font-weight-bold mb-10 mb-md-5 text-md-h4 text-h4 text-uppercase text-md-start text-center"},[_vm._v(_vm._s(_vm.first)+_vm._s(_vm.sec))])
}
var staticRenderFns = []

export { render, staticRenderFns }